import React from 'react';
import Card from 'react-bootstrap/Card';
import '../styles/project.css'; // 스타일 추가
import ListGroup from 'react-bootstrap/ListGroup';
import { Image,Badge } from 'react-bootstrap';

const Project = ({ imgName,title, description, features, stack,url }) => {
    let imagePath;
    try {
    imagePath = require(`../img/${imgName}.png`);
    } catch (error) {
      try {
        imagePath = require(`../img/${imgName}.jpg`);
      } catch (error) {
        try {
          imagePath = require(`../img/${imgName}.gif`);
        } catch (error) {
          console.error("이미지를 찾을 수 없습니다:", imgName);
        }
      }
    }

    // 기술 스택을 뱃지로 변환
    const stackBadges = {
      "JavaScript": "https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black",
      "JQuery": "https://img.shields.io/badge/jQuery-0769AD?style=for-the-badge&logo=jquery&logoColor=white",
      "Java": "https://img.shields.io/badge/Java-007396?style=for-the-badge&logo=java&logoColor=white",
      "PostgreSql": "https://img.shields.io/badge/PostgreSQL-336791?style=for-the-badge&logo=postgresql&logoColor=white",
      "Spring": "https://img.shields.io/badge/Spring-6DB33F?style=for-the-badge&logo=spring&logoColor=white",
      "Tomcat": "https://img.shields.io/badge/Apache%20Tomcat-F8DC75?style=for-the-badge&logo=apache-tomcat&logoColor=black",
      "JSP": "https://img.shields.io/badge/JSP-007396?style=for-the-badge&logo=java&logoColor=white",
      "React Native": "https://img.shields.io/badge/React%20Native-61DAFB?style=for-the-badge&logo=react&logoColor=black",
      "Bootstrap": "https://img.shields.io/badge/Bootstrap-7952B3?style=for-the-badge&logo=bootstrap&logoColor=white",
      "Docker": "https://img.shields.io/badge/Docker-2496ED?style=for-the-badge&logo=docker&logoColor=white",
      "Oracle": "https://img.shields.io/badge/Oracle-F80000?style=for-the-badge&logo=oracle&logoColor=white",
      "AWS": "https://img.shields.io/badge/AWS-232F3E?style=for-the-badge&logo=amazon-aws&logoColor=white",
      "React" : "https://img.shields.io/badge/React-61DAFB?style=for-the-badge&logo=react&logoColor=black",
      "GitHub" : "https://img.shields.io/badge/GitHub-181717?style=for-the-badge&logo=github&logoColor=white",
      "SpringBoot" : "https://img.shields.io/badge/Spring%20Boot-6DB33F?style=for-the-badge&logo=spring-boot&logoColor=white",
      "GitLab" : "https://img.shields.io/badge/GitLab-FCA121?style=for-the-badge&logo=gitlab&logoColor=white",
      "Python": "https://img.shields.io/badge/Python-3776AB?style=for-the-badge&logo=python&logoColor=white",
      "CMD": "https://img.shields.io/badge/CMD-4D4D4D?style=for-the-badge&logo=windows-terminal&logoColor=white",
      "PowerShell": "https://img.shields.io/badge/PowerShell-5391FE?style=for-the-badge&logo=powershell&logoColor=white",
      "LLM": "https://img.shields.io/badge/LLM-FF6F00?style=for-the-badge&logo=openai&logoColor=white",
      "Ollama": "https://img.shields.io/badge/Ollama-000000?style=for-the-badge&logo=ollama&logoColor=white",
      "Codex": "https://img.shields.io/badge/Codex-000000?style=for-the-badge&logo=openai&logoColor=white",
      "C#": "https://img.shields.io/badge/C%23-239120?style=for-the-badge&logo=csharp&logoColor=white",
  };
  


  return (
    <Card style={{ width: '25rem' }} className='project-card' onClick={() => window.open(url)}>
    {/* 이미지 가운데 정렬을 위해 div로 감싸기 */}
    <div className="image-container">
        <Image
          variant="top"
          src={imagePath} 
          alt={title} 
          className="project-image"
        />
      </div>

    <Card.Body>
    <ListGroup className="list-group-flush">
        <ListGroup.Item>
            <h5 style={{textAlign: 'center',fontWeight:"bold"}} >
            {title}
            </h5>
        </ListGroup.Item>
        <ListGroup.Item style={{textAlign: 'center'}}>
            {description}
        </ListGroup.Item>
        <ListGroup.Item style={{textAlign: 'center'}}>
            {features.map((feature, index) => (
                <ul key={index}>{feature}</ul>
            ))}
        </ListGroup.Item>
    </ListGroup>
        
        {/* <Card.Text style={{textAlign: 'center'}}>
            {stack}
        </Card.Text> */}
        {/* 기술 스택을 뱃지로 표시 */}
        <Card.Text style={{textAlign: 'center', marginTop: '10px'}}>
                    {stack.split(',').map((tech, index) => (
                        <img 
                            key={index} 
                            src={stackBadges[tech.trim()]} 
                            alt={tech} 
                            style={{ margin: '5px', height: '30px' }}
                        />
                    ))}
                </Card.Text>
    </Card.Body>
  </Card>
  );
}

export default Project;
